import { Grid } from '@mui/material'
import IndexTile from './index-tile'

export default function IndexPulse() {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <IndexTile symbol='SPY' label='S&P 500' />
      </Grid>
      <Grid item xs={12} md={4}>
        <IndexTile symbol='QQQ' label='Nasdaq 100' />
      </Grid>
      <Grid item xs={12} md={4}>
        <IndexTile symbol='DIA' label='Dow Jones' />
      </Grid>
    </Grid>
  )
}
